<template>
  <div class="board-container">
    <div class="board">
      <div v-for="(row, i) in userMap" class="row">
        <div v-for="(cell, j) in row" class="cell" :class="{
          close: cell === null,
          empty: cell === 0,
          'non-empty': cell > 0,
          mine: cell === -1,
          [`color-${cell}`]: cell > 0,
        }"
        @click="$emit('open', [i, j])" @contextmenu.prevent="$emit('flag', [i, j])">
          <template v-if="cell !== -2">
            {{ cell }}
          </template>
          <img v-else src="@/assets/flag.jpg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Board',
  props: {
    userMap: {type: Array, required: true},
    map: {type: Array, required: true},
    config: {type: Object, required: true},
  },
  emits: {
    open: {},
    flag: {}
  }
}
</script>

<style scoped>
.board-container {
  display: flex;
}
.board {
  outline: 1px solid black;
}
.row {
  display: flex;
  height: 2em;
  user-select: none;
}
.cell {
  width: 2em;
  height: 2em;
  line-height: 2;
  text-align: center;
  font-weight: bold;
  outline: 1px solid black;
  outline-offset: -1px;
}
.cell.close {
  cursor: pointer;
}
.cell.empty {
  background: #ddd;
  color: transparent;
}
.cell.mine {
  background: yellow;
}
.cell.non-empty {
  background: #ddd;
}
.color-1 { color: blue }
.color-2 { color: green }
.color-3 { color: red }
.color-4 { color: darkblue }
.color-5 { color: darkred }
.color-6 { color: chocolate }
.color-7 { color: black }
.color-8 { color: black }

</style>
